import { useTranslation } from 'react-i18next';
import { productConfig } from '@shared/config';
import { Badge } from '@/components/ui';
import { usePageMeta } from '@/lib/seo';

export function LegalPage({ type }: { type: 'privacy' | 'terms' }) {
  const { t } = useTranslation('legal');
  const sections = t(`${type}.sections`, {
    returnObjects: true,
  }) as Array<{ title: string; body: string }>;
  const title = t(`${type}.title`);
  usePageMeta({ title, description: t(`${type}.intro`) });
  return (
    <div className="legal-page section-pad">
      <div className="container legal-page__container">
        <Badge tone="brand">{productConfig.brandName} beta</Badge>
        <h1>{title}</h1>
        <p className="legal-page__intro">{t(`${type}.intro`)}</p>
        <p className="legal-notice">{t('notice')}</p>
        <div className="legal-sections">
          {sections.map((section) => (
            <section
              key={section.title}
              id={
                section.title.toLowerCase() === 'contact' || section.title === 'التواصل'
                  ? 'contact'
                  : undefined
              }
            >
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
